import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import PropTypes from 'prop-types';

const AAFModalActivate = (props = {}) => {
  const title = Translator.get('activateTelmexmexicogate_modal_title','Activa tu sucripción');
  const content = Translator.get('activateTelmexmexicogate_modal_description','Activa tu medio de pago Telmex llamando por unica vez al 333 desde el número que ingresaste.');

  const p = {
    content,
    title,
    alwaysEnabled: true,
    buttonsAlign: 'vertical',
    buttons: [
      {
        content: Translator.get('activateTelmexmexicogate_modal_option_button_close', 'Entendido'),
        props: {
          onClick: (e) => {props.handleClose(e, props.callback);},
          className: 'aaf-modal-button aaf-modal-button-primary'
        }
      }
    ],
    aafNewStyle: true,
    className: 'aaf-modal',
    showLogo: true,
  }
  return <ModalWrapper {...p} />;
}

AAFModalActivate.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string
}

export default withOnClose(AAFModalActivate);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalActivate.jsx